<template>
	<div class="container">
		<div class="server">
			<div class="server-img">
				<div class="server-img-content">
					<div class="server-ic-view">
						<h2 class="server-ic-view-h2">企业增值服务</h2>
						<h4 class="server-ic-view-h4">视频面试/视频会议/网络课堂等</h4>
						<div>
							<button class="server-ic-view-btn" type="button">立即下载</button>
						</div>
					</div>
				</div>
			</div>
			<div class="server-body">
				<h2 class="server-body-h2 server-body-h2-1">增值服务</h2>
				
				<div class="server-body-view server-body-view-1">
					<div class="server-body-list" v-for="(s,i) in inter" :key="i">
						<div class="server-body-img"><img :src="`../../../static/inter_${i+1}.png`" alt=""></div>
						<div class="server-body-title">{{s}}</div>
					</div>
				</div>
				
				<h2 class="server-body-h2 server-body-h2-2">带来的价值</h2>
				
				<div class="server-body-view server-body-view-2">
					<div class="server-body-1-list" v-for="(s,i) in cost" :key="i">
						<div class="server-body-1-img"><img :src="`../../../static/cost_${i+1}.png`" alt=""></div>
						<div class="server-body-1-content">
							<div class="server-body-1-title">{{s.title}}</div>
							<div class="server-body-1-sub">{{s.sub_title}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'EnterprieServerThree',
		data(){
			return {
				inter:[`视频面试`,`视频会议`,`网络课堂`],
				cost:[
					{
						title:'减少招聘成本',
						sub_title:'通过一对一/一对多远程视频面试 筛选, 提升人岗匹配度,节约企业 招聘成本'
					},
					{
						title:'提升工作效率',
						sub_title:'视频会议毋需出差员工匆忙回赶, 提升工作效率'
					},
					{
						title:'节约培训支出',
						sub_title:'利用播聘的课堂, 培训员工的专业 能力, 节约培训支出'
					}
				]
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("./enterprise-server-three.css");
</style>



// WEBPACK FOOTER //
// src/pages/enterprise-server-three/enterprise-server-three.vue